import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export interface CanComponentDeactivate {
    hasDashboardBeenEdited: boolean;
    hasAlertBeenPrompted: boolean;
    callPrompt(url: string): void;
}

@Injectable()
export class ManageDashboardsGuard {
    canDeactivate(
        component: CanComponentDeactivate,
        _currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ) {
        if (component.hasDashboardBeenEdited) {
            if (!component.hasAlertBeenPrompted) {
                component.callPrompt(nextState.url);
            }
            return false;
        } else {
            return true;
        }
    }
}
